import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy, CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function KidsStormTroopers() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2006">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2007">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-2008">
          <div className="order-2 lg:order-1" data-id="element-2009">
            <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-2010">
              <Trophy className="w-3.5 h-3.5" data-id="element-2011" />
              Ages 6+
            </div>
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-2012">
              Kids Taekwondo / Storm Troopers
            </h2>
            <p className="text-lg text-gray-warm mb-6" data-id="element-2013">
              Once kids hit age 6, they're ready for full Taekwondo training.
              Storm Troopers classes blend serious skill-building with the
              positive, encouraging atmosphere parents tell us is the reason
              their kids actually want to come back.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-2014">
              {['Olympic-style Taekwondo (WT / Kukkiwon aligned)', 'Belt progression with clear, age-appropriate goals', 'Sparring fundamentals in a controlled, safe environment', 'Forms (poomsae), kicks, and self-defense techniques', 'A peer group of kids working toward the same goals'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-2015">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-2016" />
                  <span className="text-ink" data-id="element-2017">{item}</span>
                </li>)}
            </ul>
            <Link to="/kids-taekwondo-classes-in-farmington-hills-michigan" className="text-storm-red font-bold hover:underline inline-flex items-center gap-1" data-id="element-2018">
              See Kids Taekwondo Details →
            </Link>
          </div>
          <div className="order-1 lg:order-2" data-id="element-2019">
            <img src={SITE_IMAGES.kidsClasses} alt="Storm Troopers kids Taekwondo class" className="block rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-2020" />
          </div>
        </div>
      </div>
    </section>;
}